import { useEffect } from 'react';

let lockCount = 0;
let previousBodyOverflow;
let previousHtmlOverflow;
let previousBodyPaddingRight;

const canUseDom = () => typeof document !== 'undefined' && document?.body;

const getScrollbarWidth = () => {
  if (!canUseDom()) return 0;
  return window.innerWidth - document.documentElement.clientWidth;
};

const applyLock = () => {
  if (!canUseDom()) return;

  if (lockCount === 0) {
    previousBodyOverflow = document.body.style.overflow;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;

    const scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    // Compensate to prevent layout shift when scrollbar disappears
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  lockCount += 1;
};

const releaseLock = () => {
  if (!canUseDom()) return;
  if (lockCount === 0) return;

  lockCount -= 1;

  if (lockCount === 0) {
    document.body.style.overflow = previousBodyOverflow || '';
    document.documentElement.style.overflow = previousHtmlOverflow || '';
    document.body.style.paddingRight = previousBodyPaddingRight || '';
    previousBodyOverflow = undefined;
    previousHtmlOverflow = undefined;
    previousBodyPaddingRight = undefined;
  }
};

const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked) return undefined;

    applyLock();
    return () => releaseLock();
  }, [isLocked]);
};

export default useBodyScrollLock;
